import advancedMLE from './logos/advanced-ml-engineer.png';
import aiPractitioner from './logos/ai-practitioner.png';
import securitySpecialty from './logos/security-specialty.png';
import developerAssociate from './logos/developer-associate.png';
import machineLearningSpecialty from './logos/machine-learning-specialty.png';
import advancedNetworkingSpecialty from './logos/advanced-networking-specialty.png';
import alexaSkillBuilderSpecialty from './logos/alexa-skill-builder-specialty.png';
import solutionsArchitectAssociate from './logos/solutions-architect-associate.png';
import connectaifun from './logos/connectaifun.png';
import connectcomm from './logos/connectcomm.png';
import connectdev from './logos/connectdev.png';
import connectfun from './logos/connectfun.png';
import skypeforbusiness from './logos/skypeforbusiness.png';
import mcsao365 from './logos/mcsao365.png';
import mcseproductivity from './logos/mcseproductivity.png';
import coreskype from './logos/coreskype.png';
import manageing0365 from './logos/manageing0365.png';
import terraform from './logos/terraform.png';
import azureai from './logos/azure-ai-engineer-associate.png';
import fabric from './logos/fabric.png';
import azureaifun from './logos/azureaifun.png';
import ccie from './logos/ccie.png';
import ccna from './logos/ccna.png';
import ccnp from './logos/ccnp.png';
import ccvp from './logos/ccvp.png';
import salesforceaiass from './logos/salesforceaiass.png';
import sfagentforce from './logos/sfagentforce.png';
import accenture from './logos/accenture.png';
import toku from './logos/toku.png';
import aws from './logos/aws.png';
import twilio from './logos/twilio.svg';
import microsoft from './logos/microsoft.svg';
import connect from './logos/connect.webp';
import cognigy from './logos/cognigy.png'
import accenture_reinvention from './logos/accenture_reinvention.png'
import standardChartered from './logos/standardchartered.png'
import sky from './logos/sky.png'
import dhlExpress from './logos/dhlexpress.png'
import iras from './logos/iras.png'
import oppo from './logos/oppo.png'
import dominos from './logos/dominos.png'
import origin from './logos/origin.png'
import commonwealthBank from './logos/commonwealthbank.svg'
import nab from './logos/nab.png'
import globe from './logos/globe.png'
import uofw from './logos/uofw.png'
import aip from './logos/aws-certified-generative-ai-developer-professional.png'
const sampleData = {
    name: 'Robert Hockley',
    title: '',
    role: 'AI & Customer Experience Transformation Leader',
    location: 'Singapore',
    photo: 'https://placehold.co/200x200',
    email: 'rhockley@hotmail.com',
    phone: '+65 8913 5961',
    website: 'https://robert-hockley.com',
    summary:
        ['Senior technology and customer experience leader with deep roots in enterprise communications, cloud platforms, and AI-enabled contact centre transformation. Trusted to design and deliver secure, scalable solutions across government, financial services, telecommunications, and global enterprise environments.',
            ' Built a career at the intersection of voice, cloud, and customer experience platforms, leading large-scale migrations, platform modernisation, and AI-driven transformation initiatives across APAC, EMEA, and North America. Known for navigating complex, regulated environments and translating emerging technologies into measurable business outcomes.'
        ],
    skills: [
        'AI & Contact Centre Transformation',
        'Customer Experience & Journey Design',
        'Enterprise Solution Architecture',
        'Cloud & Platform Governance',
        'Security & Compliance (Regulated Environments)',
        'Stakeholder & Executive Engagement',
        'RFP / RFI Strategy & Delivery',
        'Operating Model & Delivery Leadership'
    ],
    tech: [
        'AWS (Amazon Connect, Lex, Lambda, Bedrock, S3, Security Hub, EC2, ECS, CloudFormation, DynamoDB, Secrets Manager, Kinesis)',
        'Salesforce (Service Cloud, Omni-Channel)',
        'Microsoft (Azure, Teams, Skype for Business)',
        'Terraform & Infrastructure as Code',
        'React & API-driven Interfaces',
        'Contact Centre AI (Voicebots, Chatbots, NLP, Next Best Action, Email Auto Summarisation and Reply) including Cogngiy, Amazon Web Services, Twilio and Cisco',
    ],
    experience: [
        {
            role: 'Senior Manager Data and AI Delivery',
            company: 'Accenture Song',
            period: 'September 2024 - Present',
            location: 'Singapore',
            maxBullets: 5,
            mainStrong: 'Senior technology and AI delivery leader',
            main: 'with 8+ years of experience designing and delivering enterprise-scale digital and AI solutions. Proven track record driving customer experience transformation, operational efficiency, and secure cloud platforms across regulated and high-trust environments.',
            responsibilities: [
                {
                    lead: 'Led end-to-end design and delivery of AI-enabled contact centre solutions',
                    detail:
                        'driving measurable improvements in agent productivity, response quality, and customer experience across voice, chat, email, and digital channels.'
                },
                {
                    lead: 'Owned the strategy, design, and execution of a contact centre RFI',
                    detail:
                        'embedding AI-powered chatbots and voicebots to deliver real-time, actionable agent assistance.'
                },
                {
                    lead: 'Improved agent efficiency and reduced post-call workload',
                    detail:
                        'by implementing Case Summary and Next Best Action solutions using prompt engineering and API-driven automation.'
                },
                {
                    lead: 'Architected an AI-enhanced inbound email solution',
                    detail:
                        'that summarized customer queries, detected intent, queried knowledge bases, and generated intelligent draft responses.'
                },
                {
                    lead: 'Designed and delivered a React-based supervisory management interface,',
                    detail:
                        'enabling contact centre leaders to monitor, manage, and optimize customer interactions, improving operational visibility and control.'
                },
                {
                    lead: 'Contributed to and shaped two large-scale contact centre RFPs,',
                    detail:
                        'applying AI and automation to differentiate service propositions and strengthen Accenture\'s competitive positioning.'
                },
                {
                    lead: 'Delivered multiple Proofs of Concept',
                    detail:
                        'to validate AI solutions in production-like environments, ensuring technical feasibility, business alignment, and client confidence.'
                },
                {
                    lead: 'Led a Proof of Concept for an RFP integrating Amazon Connect with Salesforce,',
                    detail:
                        'including the new Bring Your Own Channel capability (SCC-AC), demonstrating scalable omnichannel architecture and seamless CRM integration.'
                }
            ],
            logo: accenture
        },
        {
            role: 'VP Head of Solution Architects ',
            company: 'Toku',
            period: 'July 2023 - September 2024',
            location: 'Singapore',
            maxBullets: 4,
            mainStrong: 'Senior cloud and solution architecture leader,',
            main: 'responsible for designing and governing security-critical platforms across regulated and government environments, with a strong focus on scalability, compliance, and operational excellence.',
            responsibilities: [
                {
                    lead: 'Led the design and deployment of Terraform-based infrastructure',
                    detail:
                        'for a high-profile government department, establishing infrastructure-as-code standards that improved consistency, reliability, and operational scalability.'
                },
                {
                    lead: 'Defined and implemented AWS Security Hub best practices,',
                    detail:
                        'strengthening cloud security posture and ensuring alignment with stringent regulatory and compliance requirements.'
                },
                {
                    lead: 'Drove cloud cost optimization initiatives,',
                    detail:
                        'including a redesign of AWS Lambda cold-start mechanisms, improving runtime efficiency while delivering measurable cost savings.'
                },
                {
                    lead: 'Established controlled console access and change-management governance,',
                    detail:
                        'enforcing least-privilege access and improving accountability across engineering and operations teams.'
                },
                {
                    lead: 'Operated in highly secure government environments,',
                    detail:
                        'achieving G50 clearance and demonstrating the ability to lead delivery in high-trust, mission-critical contexts.'
                }
            ],
            logo: toku
        },
        {
            role: 'Senior Solution Architect',
            company: 'Twilio',
            period: 'September 2021 - May 2023',
            location: 'Singapore',
            maxBullets: 4,
            mainStrong: 'Senior customer experience and communications solutions leader,',
            main: 'designing and delivering cloud-based contact centre, IVR, and AI-enabled experiences to improve customer journeys and operational efficiency.',
            responsibilities: [
                {
                    lead: 'Led requirements discovery and solution design across multiple customer experience initiatives,',
                    detail:
                        'defining call flows and IVRs to optimize end-to-end customer journeys.'
                },
                {
                    lead: 'Delivered an AI-powered audio analytics solution,',
                    detail:
                        'analysing call recordings to redact PII and perform keyword-based escalation via Slack, significantly improving case triage and handling efficiency.'
                },
                {
                    lead: 'Designed and implemented personalized IVR experiences,',
                    detail:
                        'greeting callers by name and dynamically routing journeys based on open cases, enabling seamless case creation and transitions within Dynamics 365.'
                },
                {
                    lead: 'Developed React-based web applications and custom CRM integrations,',
                    detail:
                        'leveraging APIs to improve accessibility, usability, and system extensibility.'
                },
                {
                    lead: 'Built administrative portals for operational control,',
                    detail:
                        'enabling teams to manage holidays, hours of operation, and service outages with improved visibility and governance.'
                },
                {
                    lead: 'Enabled CRM and contact centre integration across multiple BPO support teams,',
                    detail:
                        'ensuring consistent customer experiences and effective coordination across outsourced operations.'
                }
            ],
            logo: twilio
        },
        {
            role: 'Senior Amazon Connect Specialist (Global Specialty Practice)',
            company: 'Amazon Web Services (AWS)',
            period: 'October 2017 - September 2021',
            location: 'Singapore',
            maxBullets: 5,
            mainStrong: 'Senior customer experience and cloud solutions specialist within the global Amazon Connect specialty practice,',
            main: 'designing and delivering scalable, AI-enabled contact centre solutions across voice and chat for enterprise customers.',
            responsibilities: [
                {
                    lead: 'Led requirements discovery and solution design for Amazon Connect-based customer support platforms,',
                    detail:
                        'delivering integrated voice and chat experiences enhanced with AI-driven capabilities such as natural language understanding, sentiment analysis, and transcription.'
                },
                {
                    lead: 'Designed and implemented end-to-end contact centre architectures',
                    detail:
                        'leveraging Amazon Connect, Amazon Lex, Amazon Polly, AWS Lambda, Amazon S3, and Amazon Kinesis to improve operational efficiency and customer experience.'
                },
                {
                    lead: 'Automated infrastructure deployment using AWS CloudFormation,',
                    detail:
                        'ensuring consistent, scalable, and repeatable environments across customer implementations.'
                },
                {
                    lead: 'Took end-to-end ownership of complex customer engagements,',
                    detail:
                        'acting as a senior technical lead and trusted advisor for design decisions and delivery execution.'
                },
                {
                    lead: 'Authored and published multiple Amazon Connect technical blog posts,',
                    detail:
                        'sharing insights and best practices for building and scaling contact centre solutions on AWS.enabling customers to solve common challenges and adopt best practices at scale.'
                }
            ],
            logo: aws
        },
        {
            role: 'Cloud Solution Architect (Unified Communications)',
            company: 'Microsoft',
            period: 'October 2016 - September 2017',
            location: 'Australia',
            maxBullets: 3,
            mainStrong: 'Cloud solutions architect',
            main: 'focused on unified communications, enabling partners and customers to transition Skype for Business workloads to the cloud through structured migration planning and technical enablement.',
            responsibilities: [
                {
                    lead: 'Led solution design evaluations and cloud migration planning,',
                    detail:
                        'supporting partners and customers in transitioning unified collaboration environments to Microsoft\'s cloud platforms.'
                },
                {
                    lead: 'Delivered partner enablement sessions and roadmap discussions,',
                    detail:
                        'aligning technical architecture with business objectives and long-term cloud strategies.'
                },
                {
                    lead: 'Presented at industry conferences,',
                    detail:
                        'sharing best practices and contributing to thought leadership in unified communications and cloud adoption.'
                },
                {
                    lead: 'Advised customers on workload suitability and migration readiness,',
                    detail:
                        'clarifying technical and operational requirements to support successful cloud transitions.'
                }
            ],
            logo: microsoft
        },
    ],
    projects: [
        {
            role: 'Conversational AI PoC Delivery Lead',
            company: 'Standard Chartered Bank',
            period: 'December 2025 - March 2026',
            location: 'Singapore',
            mainStrong: 'AI and conversational experience delivery lead',
            main: 'delivering a bank-ready Proof of Concept that validated Cognigy\'s intent recognition approaches (NLU vs LLM), implemented privacy-by-design controls for PII handling, and built a custom React escalation console integrating Cognigy with Amazon Connect to enhance agent handover and supervision workflows.',
            responsibilities: [
                {
                    lead: 'Developed and deployed a Cognigy Proof of Concept to validate intent recognition approaches',
                    detail:
                        'comparing traditional NLU classification versus LLM-based intent detection to inform the bank\'s conversational AI strategy and future build decisions.'
                },
                {
                    lead: 'Implemented privacy-by-design PII controls across the conversational pipeline',
                    detail:
                        'including input-side PII redaction and secure storage of sensitive fields in a Secrets Manager for later retrieval and use with internal banking APIs.'
                },
                {
                    lead: 'Built a custom React escalation application integrating Cognigy chat handover with Amazon Connect',
                    detail:
                        'enabling seamless agent escalation and improving operational usability for live support scenarios.'
                },
                {
                    lead: 'Delivered enhanced agent context features within the escalation console',
                    detail:
                        'including sentiment detection, full transcripts with search functionality, and automated transcript summarisation to reduce agent ramp time and improve resolution quality.'
                },
                {
                    lead: 'Acted as an advisor on the bank\'s future agentic AI chatbot roadmap',
                    detail:
                        'providing documentation and design input for next-generation capabilities such as tool-use orchestration, workflow automation, and governed autonomous actions.'
                }
            ],
            logo: standardChartered
        },
        {
            role: 'Voice & Integration Lead – Conversational AI',
            company: 'Sky Germany',
            period: 'December 2025 to Present',
            location: 'Germany (Remote)',
            mainStrong: 'Voice integration and enterprise conversational AI specialist',
            main: 'leading the end-to-end voice integration of Cognigy into Sky\'s existing telephony landscape, enabling secure SIP connectivity, enriched call context propagation, and CRM integration to support seamless customer service operations.',
            responsibilities: [
                {
                    lead: 'Led the voice integration of Cognigy into Sky\'s telephony environment',
                    detail:
                        'designing and implementing SIP connectivity to the existing Session Border Controller (SBC), ensuring secure, scalable, and production-ready voice routing.'
                },
                {
                    lead: 'Defined and implemented custom SIP X-Headers for contextual call enrichment',
                    detail:
                        'including Initial Call ID, Cognigy Call ID, Phone Number, Customer ID, Intent, Routing Information, Salesforce Case ID, and Recording Consent to enable end-to-end traceability and intelligent routing.'
                },
                {
                    lead: 'Enabled downstream system integration through structured call metadata propagation',
                    detail:
                        'ensuring conversational insights and routing decisions were consistently passed between telephony, Cognigy, and CRM platforms.'
                },
                {
                    lead: 'Advised on Salesforce integration strategy',
                    detail:
                        'providing architectural guidance for API-based case creation and CRM synchronization to support automated service workflows and improved agent context.'
                }
            ],
            logo: sky
        },
        {
            role: 'Backend & Voice Integration Lead – Conversational AI',
            company: 'DHL Express',
            period: 'July 2025 - January 2026',
            location: 'Germany / Singapore',
            mainStrong: 'Backend engineering and voice integration lead for enterprise conversational AI',
            main: 'leading backend development and voice integration for a Cognigy-based conversational AI solution, enabling enriched telephony metadata, real-time sentiment and transcript intelligence, and seamless agent context within Genesys through a structured Proof of Concept and UAT validation.',
            responsibilities: [
                {
                    lead: 'Led backend development for a Cognigy conversational AI implementation',
                    detail:
                        'designing and delivering scalable services to support call processing, metadata handling, and integration with downstream contact centre platforms.'
                },
                {
                    lead: 'Delivered voice integration and SIP X-Header definition for Genesys routing',
                    detail:
                        'defining and propagating structured call metadata to support intelligent routing, caller identification, and end-to-end traceability across systems.'
                },
                {
                    lead: 'Implemented transcript summarisation and sentiment analysis capabilities',
                    detail:
                        'generating real-time conversational insights and pushing structured outputs into Genesys Call Attributes to enhance agent awareness and decision-making.'
                },
                {
                    lead: 'Updated and mapped Genesys Call Attributes to surface AI-driven insights to agents',
                    detail:
                        'ensuring summaries, sentiment indicators, and contextual metadata were available directly within the agent workspace.'
                },
                {
                    lead: 'Delivered a structured Proof of Concept with formal UAT validation',
                    detail:
                        'demonstrating technical feasibility, business value, and operational readiness prior to wider rollout.'
                },
                {
                    lead: 'Provided advisory input on architecture and future-state conversational AI capabilities',
                    detail:
                        'supporting strategic decisions around scalability, governance, and long-term integration patterns.'
                }
            ],
            logo: dhlExpress
        },
        {
            role: 'AI Agent Assist & Automation Lead',
            company: 'Accenture / DHL (Government Support)',
            period: 'May 2025 - September 2025',
            location: 'Singapore',
            mainStrong: 'Lead architect and developer for proactive AI-driven contact centre transformation',
            main: 'designed and delivered a multi-channel AI Agent Assist platform to reduce contact centre costs and improve agent proactivity, leveraging Amazon Connect, LLM-based intent detection, voice-optimised knowledge retrieval, and custom React-based agent desktop applications.',
            responsibilities: [
                {
                    lead: 'Designed and built a real-time AI Agent Assist solution for voice calls',
                    detail:
                        'actively streaming Amazon Connect transcripts to a custom backend for multi-turn LLM-based intent detection and contextual understanding.'
                },
                {
                    lead: 'Implemented intelligent knowledge retrieval and real-time agent response delivery',
                    detail:
                        'querying a voice-optimised knowledge base once intent was detected and delivering suggested responses to agents via WebSockets within a custom React-based desktop application.'
                },
                {
                    lead: 'Enabled agent feedback loops to improve AI response quality',
                    detail:
                        'providing manual knowledge base search and thumbs up/down response rating, persisting structured feedback into DynamoDB to support continuous optimisation.'
                },
                {
                    lead: 'Engineered an enhanced post-call summary and next-steps generator',
                    detail:
                        'overcoming Amazon Connect\'s 1,762-character summary limitation by building a custom transcript processing service that generated comprehensive summaries and actionable next steps for agent review before CRM submission.'
                },
                {
                    lead: 'Delivered AI-assisted inbound email automation',
                    detail:
                        'intercepting contact centre emails, applying LLM-based intent detection, querying the knowledge base to generate draft responses, and presenting editable suggestions within a custom React-based agent interface.'
                },
                {
                    lead: 'Developed reusable deployment and enablement assets',
                    detail:
                        'creating Terraform templates for repeatable infrastructure deployment, alongside demo and installation video guides to accelerate adoption across Accenture teams.'
                }
            ],
            logo: accenture
        },
        {
            role: 'Cloud Security & Infrastructure Lead',
            company: 'Inland Revenue Authority of Singapore (IRAS)',
            period: 'July 2023 - September 2024',
            location: 'Singapore',
            mainStrong: 'Cloud security, governance, and infrastructure-as-code leader in regulated government environments',
            main: 'led the secure design and deployment of a new AWS-based contact centre platform within a government environment, establishing Terraform-driven infrastructure standards, strengthening cloud security posture, and ensuring full compliance with IM8 and public sector best practices.',
            responsibilities: [
                {
                    lead: 'Led secure AWS account setup for a government contact centre platform',
                    detail:
                        'ensuring adherence to Singapore Government IM8 policies, regulatory controls, and public sector cloud best practices within a newly established AWS environment.'
                },
                {
                    lead: 'Designed and deployed Terraform-based infrastructure-as-code foundations',
                    detail:
                        'establishing repeatable, auditable, and scalable infrastructure standards that improved delivery consistency and operational reliability.'
                },
                {
                    lead: 'Strengthened cloud security posture through AWS Security Hub and vulnerability management',
                    detail:
                        'defining and implementing Security Hub best practices, proactively identifying vulnerabilities, and driving remediation to maintain compliance in a high-trust environment.'
                },
                {
                    lead: 'Implemented governance, least-privilege access, and controlled console management',
                    detail:
                        'establishing structured access controls and change-management processes to improve accountability across engineering and operations teams.'
                },
                {
                    lead: 'Drove cloud cost optimisation initiatives',
                    detail:
                        'redesigning AWS Lambda cold-start mechanisms and runtime patterns to improve performance efficiency while delivering measurable cost savings.'
                },
                {
                    lead: 'Delivered in a highly secure government context with G50 clearance',
                    detail:
                        'operating effectively within mission-critical, security-sensitive environments while maintaining compliance, stakeholder trust, and delivery excellence.'
                }
            ],
            logo: iras
        },
        {
            role: 'Global Contact Centre Transformation Lead',
            company: 'OPPO',
            period: 'July 2022 - May 2023',
            location: 'China (Remote)',
            mainStrong: 'Global contact centre architecture and delivery leader',
            main: 'led the design and deployment of a 63-country voice customer service platform using Twilio Flex, delivering a scalable, multilingual, cloud-based contact centre with custom React agent desktops, SIP integrations, and infrastructure-as-code deployment templates to enable global expansion and client enablement.',
            responsibilities: [
                {
                    lead: 'Led the end-to-end design and global rollout of a 63-country voice contact centre platform',
                    detail:
                        'architecting a scalable Twilio Flex solution supporting phased country launches, structured governance, and repeatable deployment patterns.'
                },
                {
                    lead: 'Designed and delivered custom React-based agent desktops',
                    detail:
                        'building tailored user interfaces to support local operational requirements, CRM integrations, and enhanced agent workflows.'
                },
                {
                    lead: 'Implemented SIP connectivity via Session Border Controllers (SBCs)',
                    detail:
                        'ensuring secure and reliable voice routing across global telephony providers and regional infrastructure constraints.'
                },
                {
                    lead: 'Enabled multilingual support across 30 languages',
                    detail:
                        'designing routing logic, IVR flows, and operational models to support diverse regional customer bases at global scale.'
                },
                {
                    lead: 'Integrated multiple custom CRMs and backend APIs',
                    detail:
                        'enabling real-time customer data retrieval, case management, and workflow automation within the Flex environment.'
                },
                {
                    lead: 'Established Terraform-based deployment templates for global scalability',
                    detail:
                        'creating reusable infrastructure-as-code patterns that enabled controlled, consistent country rollouts and simplified operational support.'
                },
                {
                    lead: 'Enabled client self-sufficiency through templated rollout and structured UAT phases',
                    detail:
                        'designing a phased deployment model with country-level UAT cycles, empowering OPPO teams to independently launch additional markets post-programme.'
                }
            ],
            logo: oppo
        },
        {
            role: 'Contact Centre Migration & AI Strategy Lead',
            company: 'Origin Energy',
            period: 'January 2022 - August 2022',
            location: 'Australia (Remote)',
            mainStrong: 'Telephony migration strategist and early-stage conversational AI innovator',
            main: 'devised and led a strategic migration plan from Amazon Connect to Twilio, overcoming telephony integration constraints through intelligent number planning and call correlation design, while pioneering an early interactive AI model for transcript-wide intent recognition and keyword intelligence.',
            responsibilities: [
                {
                    lead: 'Designed the migration strategy from Amazon Connect to Twilio',
                    detail:
                        'defining architecture, transition sequencing, and integration patterns to move away from platform limitations while maintaining service continuity.'
                },
                {
                    lead: 'Engineered a telephony number correlation and identification framework',
                    detail:
                        'developing a structured number plan to accurately identify and reconcile calls originating in Amazon Connect and traversing into Twilio, enabling seamless linkage to pre-identified customer data.'
                },
                {
                    lead: 'Resolved platform constraints including lack of SBC connectivity',
                    detail:
                        'designing alternative routing and identification mechanisms to ensure reliable call tracking and data consistency across platforms.'
                },
                {
                    lead: 'Pioneered an interactive AI-driven transcript intelligence model',
                    detail:
                        'implementing intent recognition and keyword search across all stored transcripts, enabling operational insight and advanced search capabilities at a time when such solutions were not commercially available.'
                },
                {
                    lead: 'Established foundations for AI-enabled operational analytics',
                    detail:
                        'demonstrating the value of transcript intelligence for compliance monitoring, customer insight, and service optimisation in an emerging AI market.'
                }
            ],
            logo: origin
        },
        {
            role: 'Voice Solution Architect',
            company: 'Domino\'s Pizza',
            period: 'November 2021 - April 2022',
            location: 'Australia (Remote)',
            mainStrong: 'Intelligent voice routing and telephony solution designer',
            main: 'designed and delivered a global voice routing solution enabling customers to connect seamlessly to their nearest local store using suburb names or postcodes, incorporating intelligent matching and scoring to handle Australian dialects, spelling variations, and ambiguous inputs.',
            responsibilities: [
                {
                    lead: 'Designed the global inbound phone line architecture',
                    detail:
                        'creating a scalable voice solution that routed customers to their local Domino\'s store based on natural language suburb or postcode input.'
                },
                {
                    lead: 'Implemented intelligent store matching and ranking logic',
                    detail:
                        'returning the five closest stores and applying a custom scoring mechanism to determine the best match based on proximity, input confidence, and linguistic similarity.'
                },
                {
                    lead: 'Engineered dialect- and spelling-tolerant input handling',
                    detail:
                        'accounting for Australian pronunciation variations, abbreviations, and common misspellings to improve routing accuracy and reduce misdirected calls.'
                },
                {
                    lead: 'Optimised customer experience through automated voice interaction design',
                    detail:
                        'reducing friction in store discovery while maintaining high routing accuracy across diverse geographic and linguistic scenarios.'
                }
            ],
            logo: dominos
        },
        {
            role: 'Conversational AI Developer',
            company: 'Commonwealth Bank of Australia',
            period: 'June 2021 - September 2021',
            location: 'Australia (Remote)',
            mainStrong: 'Internal conversational AI and automation specialist',
            main: 'designed and delivered an Amazon Lex-powered internal chatbot to streamline employee access to HR information, automating common staff FAQ queries and reducing dependency on manual support channels.',
            responsibilities: [
                {
                    lead: 'Designed and developed an internal Amazon Lex chatbot for staff self-service',
                    detail:
                        'creating conversational flows to handle common HR queries such as sick leave balances, annual leave entitlements, and policy-related FAQs.'
                },
                {
                    lead: 'Integrated the chatbot with internal systems for real-time data retrieval',
                    detail:
                        'enabling secure access to employee-specific information while maintaining compliance with enterprise security and privacy standards.'
                },
                {
                    lead: 'Automated staff FAQ delivery to reduce operational overhead',
                    detail:
                        'streamlining repetitive internal support requests and improving response times through conversational automation.'
                },
                {
                    lead: 'Delivered a scalable foundation for future internal AI use cases',
                    detail:
                        'establishing conversational design patterns and governance approaches that could be extended to additional internal automation initiatives.'
                }
            ],
            logo: commonwealthBank
        },
        {
            role: 'Cloud Contact Centre Migration Lead',
            company: 'National Australia Bank (NAB)',
            period: 'May 2019 - April 2020',
            location: 'Australia',
            mainStrong: 'Enterprise contact centre cloud transformation leader',
            main: 'led the end-to-end migration of NAB\'s on-premises contact centre platform to Amazon Connect, delivering discovery, architecture design, cloud deployment, UAT governance, and structured customer enablement for one of the bank\'s foundational cloud transformation programmes.',
            responsibilities: [
                {
                    lead: 'Led discovery and cloud migration strategy for contact centre modernisation',
                    detail:
                        'assessing legacy on-premises telephony and routing systems, defining the target-state Amazon Connect architecture, and establishing phased migration plans.'
                },
                {
                    lead: 'Designed and deployed Amazon Connect in a regulated banking environment',
                    detail:
                        'ensuring secure configuration, integration with existing banking systems, and alignment with compliance and operational requirements.'
                },
                {
                    lead: 'Managed structured UAT and validation cycles',
                    detail:
                        'coordinating business stakeholders, technical teams, and operational users to validate routing logic, integrations, and customer experience flows prior to go-live.'
                },
                {
                    lead: 'Enabled business adoption and operational readiness',
                    detail:
                        'delivering documentation, knowledge transfer, and training to ensure NAB teams were equipped to manage and evolve the cloud contact centre platform post-migration.'
                },
                {
                    lead: 'Delivered a foundational cloud transformation programme',
                    detail:
                        'supporting NAB\'s broader cloud strategy by transitioning a mission-critical customer engagement platform from on-premises infrastructure to scalable cloud-native services.'
                }
            ],
            logo: nab
        },
        {
            role: 'Cloud Contact Centre Transformation Lead',
            company: 'Globe Telecom',
            period: 'June 2018 - April 2019',
            location: 'Philippines',
            mainStrong: 'Amazon Connect transformation and partner enablement leader',
            main: 'led the migration of Globe Telecom\'s contact centre to Amazon Connect, while enabling both the customer and an implementation partner new to the platform, establishing operational foundations, solving high-impact callback challenges, and contributing to an AWS-recognised industry case study.',
            responsibilities: [
                {
                    lead: 'Led end-to-end migration from legacy contact centre to Amazon Connect',
                    detail:
                        'delivering discovery, architecture design, deployment, and operational enablement within a high-volume telecommunications environment.'
                },
                {
                    lead: 'Enabled a new delivery partner through the Amazon Connect Partner Program',
                    detail:
                        'providing hands-on technical leadership, preparing them for formal onboarding requirements including architecture presentations and developer coding assessments.'
                },
                {
                    lead: 'Designed and implemented an automated callback strategy',
                    detail:
                        'initially based on a requirement to trigger callbacks for customers waiting more than five minutes in queue.'
                },
                {
                    lead: 'Identified and resolved systemic callback duplication issues',
                    detail:
                        'detecting that customers were repeatedly calling and generating multiple callback requests, and engineering a database-backed deduplication mechanism that logged active callbacks, prevented duplicates, and removed entries upon successful completion.'
                },
                {
                    lead: 'Reduced queue congestion and abandonment rates through architectural redesign',
                    detail:
                        'addressing extreme queue volumes (1,000+ waiting customers) and eliminating duplicate callback inflation, significantly improving operational stability.'
                },
                {
                    lead: 'Delivered an AWS-recognised industry solution',
                    detail:
                        'with the callback optimisation approach becoming the basis of an AWS industry blog highlighting best practices in cloud contact centre design.'
                }
            ],
            logo: globe
        }
    ],
    education: [
        /*{
            degree: 'Bachelor of Mathematics (incomplete)',
            institution: 'University of Windsor',
            period: '1989 - 1991',
            logo: uofw,
            location: 'Canada',
            maxBullets: 5,
            mainStrong: '',
            main: 'Completed advanced coursework in mathematics, including algebra, calculus, and logic, alongside computer science and biology electives.',
            courses: [
                /*{
                    courseName: 'Fortan Concepts from Start to Finish',
                    courseDescription:
                        'Learning and compiling fortran code, and applying it to solve complex problems in a modern context.'
                },
            ]
        }*/
    ],
    certifications: [
        {
            certification: 'AWS Certified Generative AI Developer - Professional',
            provider: 'Amazon Web Services',
            date: '2026',
            logo: aip
        },
        {
            certification: 'AWS Certified Machine Learning Engineer - Associate',
            provider: 'Amazon Web Services',
            date: '2024',
            logo: advancedMLE
        },
        {
            certification: 'AWS Certified AI Practitioner',
            provider: 'Amazon Web Services',
            date: '2024',
            logo: aiPractitioner
        },
        {
            certification: 'AWS Certified Security - Specialty',
            provider: 'Amazon Web Services',
            date: '2024',
            logo: securitySpecialty
        },
        {
            certification: 'AWS Certified Developer - Associate',
            provider: 'Amazon Web Services',
            date: '2023',
            logo: developerAssociate
        },
        {
            certification: 'AWS Certified Machine Learning - Specialty',
            provider: 'Amazon Web Services',
            date: '2023',
            logo: machineLearningSpecialty
        },
        {
            certification: 'AWS Certified Advanced Networking - Specialty',
            provider: 'Amazon Web Services',
            date: '2021',
            logo: advancedNetworkingSpecialty
        },
        {
            certification: 'AWS Certified Alexa Skill Builder - Specialty',
            provider: 'Amazon Web Services',
            date: '2020',
            logo: alexaSkillBuilderSpecialty
        },
        {
            certification: 'AWS Certified Solutions Architect - Associate',
            provider: 'Amazon Web Services',
            date: '2019',
            logo: solutionsArchitectAssociate
        },
        {
            certification: 'AWS Knowledge: Amazon Connect AI Fundamentals',
            provider: 'Amazon Web Services',
            date: '2025',
            logo: connectaifun
        },
        {
            certification: 'AWS Knowledge: Amazon Connect Communications Specialist',
            provider: 'Amazon Web Services',
            date: '2024',
            logo: connectcomm
        },
        {
            certification: 'AWS Knowledge: Amazon Connect Developer',
            provider: 'Amazon Web Services',
            date: '2024',
            logo: connectdev
        },
        {
            certification: 'AWS Knowledge: Amazon Connect Fundamentals',
            provider: 'Amazon Web Services',
            date: '2025',
            logo: connectfun
        },
        {
            certification: 'MCSA: Office 365',
            provider: 'Microsoft',
            date: '2017',
            logo: mcsao365
        },
        {
            certification: 'MCSE: Productivity',
            provider: 'Microsoft',
            date: '2017',
            logo: mcseproductivity
        },
        {
            certification: 'Microsoft Certified: Azure AI Engineer Associate',
            provider: 'Microsoft',
            date: '2023',
            logo: azureai
        },
        {
            certification: 'Exam 333: Deploying Enterprise Voice with Skype for Business 2015',
            provider: 'Microsoft',
            date: '2017',
            logo: skypeforbusiness
        },
        {
            certification: 'Exam 334: Core Solutions of Microsoft Skype for Business 2015',
            provider: 'Microsoft',
            date: '2017',
            logo: coreskype
        },
        {
            certification: 'Exam 346: Managing Office 365 Identities and Requirements',
            provider: 'Microsoft',
            date: '2017',
            logo: manageing0365
        },
        {
            certification: 'Exam 347: Enabling Office 365 Services',
            provider: 'Microsoft',
            date: '2017',
            logo: null
        },
        {
            certification: 'Microsoft Certified: Fabric Analytics Engineer Associate',
            provider: 'Microsoft',
            date: '2024',
            logo: fabric
        },
        {
            certification: 'Lync 2013 Depth Support Engineer',
            provider: 'Microsoft',
            date: '2016',
            logo: null
        },
        {
            certification: 'Lync Network Readiness Specialist',
            provider: 'Microsoft',
            date: '2016',
            logo: null
        },
        {
            certification: 'Enterprise Voice & Online Services with Microsoft Lync Server',
            provider: 'Microsoft',
            date: '2015',
            logo: null
        }, {
            certification: 'Core Solutions of Microsoft Lync Server 2013',
            provider: 'Microsoft',
            date: '2015',
            logo: null
        },
        {
            certification: 'Installing, Configuring, and Administering Microsoft Exchange 2000 Server',
            provider: 'Microsoft',
            date: '2004',
            logo: null
        },
        {
            certification: 'Designing and Deploying a Messaging Infrastructure with Microsoft Exchange 2000 Server',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Migrating from Microsoft Windows NT 4.0 to Microsoft Windows 2000',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Implementing and Administering a Microsoft Windows 2000 Directory Services Infrastructure',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Implementing and Administering a Microsoft Windows 2000 Network Infrastructure',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Installing, Configuring, and Administering Microsoft Windows 2000 Server',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Installing, Configuring, and Administering Microsoft Windows 2000 Professional',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Microsoft Certified: Azure AI Fundamentals',
            provider: 'Microsoft',
            date: '2024',
            logo: azureaifun
        },

        {
            certification: 'Designing Security for a Microsoft Windows 2000 Network',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Designing a Microsoft Windows 2000 Directory Services Infrastructure',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Designing a Microsoft Windows 2000 Network Infrastructure',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        },
        {
            certification: 'Installing, Configuring, and Administering Microsoft Clustering Services by Using Microsoft Windows 2000 Advanced Server',
            provider: 'Microsoft',
            date: '2001',
            logo: null
        }, {
            certification: 'Implementing and Supporting Microsoft Proxy Server 2.0',
            provider: 'Microsoft',
            date: '1999',
            logo: null
        },
        {
            certification: 'Microsoft Sales Specialist: Core Skills Assessment',
            provider: 'Microsoft',
            date: '1998',
            logo: null
        },
        {
            certification: 'Implementing and Supporting NT Server 4.0 in the Enterprise',
            provider: 'Microsoft',
            date: '1998',
            logo: null
        },
        {
            certification: 'Implementing and Supporting Microsoft Exchange Server 5.0',
            provider: 'Microsoft',
            date: '1998',
            logo: null
        },
        {
            certification: 'Internetworking with Microsoft TCP/IP on Microsoft Windows NT 4.0',
            provider: 'Microsoft',
            date: '1998',
            logo: null
        },
        {
            certification: 'Networking Essentials',
            provider: 'Microsoft',
            date: '1998',
            logo: null
        },
        {
            certification: 'Implementing and Supporting NT Server 4.0',
            provider: 'Microsoft',
            date: '1998',
            logo: null
        },
        {
            certification: 'Implementing and Supporting NT 4.0 Workstation',
            provider: 'Microsoft',
            date: '1998',
            logo: null
        },
        {
            certification: 'HashiCorp Certified: Terraform Associate (003)',
            provider: 'Hashicorp',
            date: '2024',
            logo: terraform
        },
        {
            certification: 'CCIE Certification - Collaboration - Emeritus',
            provider: 'Cisco',
            date: '2025',
            logo: ccie
        },
        {
            certification: 'Cisco MCSE: Messaging on Microsoft Windows 2000',
            provider: 'Cisco',
            date: '2004',
            logo: null
        },
        {
            certification: 'Cisco Unity	CSE-U',
            provider: 'Cisco',
            date: '2002',
            logo: null
        },
        {
            certification: 'Cisco Unity Engineer Specialization',
            provider: 'Cisco',
            date: '2001',
            logo: null
        },
        {
            certification: 'Cisco Express Collaboration Systems Engineer Representative v2',
            provider: 'Cisco',
            date: '2013',
            logo: null
        },
        {
            certification: 'Cisco TelePresence Solutions Specialist',
            provider: 'Cisco',
            date: '2012',
            logo: null
        },
        {
            certification: 'Cisco TelePresence Video Sales Engineer for Advanced Spec',
            provider: 'Cisco',
            date: '2012',
            logo: null
        },
        {
            certification: 'Cisco TelePresence Video Sales Specialist for Master Spec',
            provider: 'Cisco',
            date: '2012',
            logo: null
        },
        {
            certification: 'Cisco Rich Media Communications Specialist',
            provider: 'Cisco',
            date: '2007',
            logo: null
        },
        {
            certification: 'Cisco IP Telephony Design Specialist',
            provider: 'Cisco',
            date: '2007',
            logo: null
        },
        {
            certification: 'Cisco IP Telephony Systems Engineer Representative',
            provider: 'Cisco',
            date: '2007',
            logo: null
        },
        {
            certification: 'CCIE Certification - Collaboration',
            provider: 'Cisco',
            date: '2006',
            logo: null
        },
        {
            certification: 'Cisco IP Communications Support Specialist',
            provider: 'Cisco',
            date: '2006',
            logo: null
        },
        {
            certification: 'Cisco IP Telephony Operations Specialist',
            provider: 'Cisco',
            date: '2006',
            logo: null
        },
        {
            certification: 'Cisco IP Telephony Operations Specialist',
            provider: 'Cisco',
            date: '2006',
            logo: null
        },
        {
            certification: 'Cisco Certified Voice Professional CCVP',
            provider: 'Cisco',
            date: '2006',
            logo: null
        },
        {
            certification: 'Cisco Certified Network Professional (CCNP) Voice',
            provider: 'Cisco',
            date: '2006',
            logo: ccvp
        },
        {
            certification: 'Cisco Unity Support Specialist',
            provider: 'Cisco',
            date: '2004',
            logo: null
        },
        {
            certification: 'Cisco IP Contact Center Express Specialist',
            provider: 'Cisco',
            date: '2004',
            logo: null
        },
        {
            certification: 'Cisco IP Contact Center Express Representative',
            provider: 'Cisco',
            date: '2004',
            logo: null
        },
        {
            certification: 'Cisco Certified Network Professional (CCNP) Routing and Switching',
            provider: 'Cisco',
            date: '2003',
            logo: ccnp
        },
        {
            certification: 'Cisco Telephony Fundamentals',
            provider: 'Cisco',
            date: '2002',
            logo: null
        },
        {
            certification: 'Cisco Certified Network Associate (CCNA) Routing and Switching',
            provider: 'Cisco',
            date: '2001',
            logo: ccna
        },
        {
            certification: 'Salesforce Certified Agentforce Specialist',
            provider: 'Salesforce',
            date: '2024',
            logo: sfagentforce
        },
        {
            certification: 'Salesforce Certified AI Associate',
            provider: 'Salesforce',
            date: '2024',
            logo: salesforceaiass
        },
        {
            certification: 'Cognigy Certified Specialist',
            provider: 'Nice Cognigy',
            date: '2025',
            logo: cognigy
        },
        {
            certification: 'Accenture - Reinvention with Agentic AI',
            provider: 'Accenture',
            date: '2026',
            logo: accenture_reinvention
        }
    ],
    printCertifications: [
        { AWS: 'Generative AI Developer - Professional, Machine Learning Engineer,AI Practitioner, Security Specialty, Developer Associate, Machine Learning Specialty, Advanced Networking Specialty, Alexa Skill Builder Specialty, Solutions Architect Associate' },
        { Microsoft: 'Azure AI Engineer Associate, Azure AI Fundamentals, Fabric Analytics Engineer Associate' },
        { Salesforce: 'Agentforce Specialist, AI Associate' },
        { HashiCorp: 'Terraform Associate' },
        { Cisco: 'CCIE Collaboration - Emeritus, CCNP Voice, CCNP Routing and Switching' },
        { "Nice Cognigy": "Cognigy Certified Specialist" }
    ],
    blogs: [
        { vendor: "AWS", link: "https://web.archive.org/web/20201113074726/https://aws.amazon.com/blogs/contact-center/creating-a-secure-emergency-outage-message-in-amazon-connect/", title: "Creating a Secure Emergency Outage Message in Amazon Connect", icon: connect },
        { vendor: "AWS", link: "https://aws.amazon.com/blogs/contact-center/preventing-duplicate-callback-requests-in-amazon-connect/", title: "Preventing Duplicate Callback Requests in Amazon Connect", icon: connect },
        { vendor: "AWS", link: "https://web.archive.org/web/20210225151314/https://aws.amazon.com/blogs/contact-center/create-a-holiday-calendar-in-amazon-connect/", title: "Create a Holiday Calendar in Amazon Connect", icon: connect },
        { vendor: "Twilio", link: "https://www.twilio.com/en-us/blog/developers/tutorials/integrations/create-emergency-outage-ivr-response-twilio-studio", title: "Create Emergency Outage IVR Response Twilio Studio", icon: twilio }
    ],
    videos: [
        { title: 'Smart Email Intelligence for Amazon Connect', link: 'https://www.youtube.com/embed/TGfp-VXDwSs?rel=0' },
        { title: 'Custom Terraform Variable Files Creator with Instructions for Apply', link: 'https://www.youtube.com/embed/ZiSzyROh_cU?rel=0' },
        { title: 'Amazon Connect Thirdparty App Install', link: 'https://www.youtube.com/embed/3sl91G2pPuQ?rel=0' },
        { title: 'Cognigy Chat with Escalation to Amazon Connect', link: 'https://www.youtube.com/embed/dAXzOkEqz-w?rel=0' },
        { title: 'Cognigy Multilingual xApps Demo', link: 'https://www.youtube.com/embed/CeFuAK7ORu8?rel=0' }
    ],
    demos: [
        //{ title: 'DHL Arabic Voice Tester', description: "A simple flow to hear Arabic voices",link: 'https://static-trial.cognigy.ai/webrtc/?token=62ab89de20f483407c7f299d1256865f23ebcfcd46713e83843e7b389199c958' },
        { title: 'Sky xAPPs',  description: "A Cognigy xApps demo to show a step-by-step process with a camera function",link: 'https://static-trial.cognigy.ai/?token=b5f809d6a1a1bdaec94f612ad126d9c5f7c5d514b9cc5949abe763d62f03c664' },
        { title: 'Redaction Chat Bot', description: "A simple demo to show the redaction capabilities of Input Transformers. The advanced demo uses AWS Secrets Manager to store sensitive information, available upon request.", link: 'https://webchat-trial.cognigy.ai/v3/be853e4b0a0b947d13cde7ba38ea47f5f35396b98abd9e3aac43e561cb44ce8a' },
        { title: 'AlpenBank', description: "A banking demo with card replacement, tax document retrieval, FAQ, balances and recent transactions. Use Account Id CUST-US-2001, Phone Number 14155550102 and PIN 482913 for the demo", link: 'https://static-trial.cognigy.ai/webrtc/?token=ad7dab0dc6b0e2e01d24cf6bc6d4c21daaeef0ba0badfcd2d70056ac4c5b7180' },
        { title: 'Language IVR Tester', description: "A demo showing an IVR tester with WebRTC. This can be used for manually testing flows in Cognigy for a language you don't speak naturally.", link: 'https://roberthockley.github.io/language-tester' }
    ]};

export default sampleData;